
































import ListItem from '@/components/ListItem.vue'
import A from '@/utilities/alpha'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { AudienceLibraryEntry } from './AudienceBuilder.vue'
import * as db from '@shared/types/database'
import { camelCaseTitle } from '@/utilities/v-track-directive'

@Component({
  components: {
    ListItem
  }
})
export default class AudiencePicker extends Vue {
  @Prop({ required: true }) readonly audienceLibrary!: AudienceLibraryEntry[]
  @Prop() readonly selectedAudience?: db.Audience

  get filteredAudienceLibrary () {
    const library = A.clone(this.audienceLibrary)
    return library.map(group => {
      if (group.title === 'Featured Audiences') {
        group.audiences = group.audiences.filter(aud => aud.id === '5da633a1d604b500042e1fb1')
      }
      return group
    })
  }

  audienceTrackingId (title: string) {
    return 'addTest-pickAudience-' + camelCaseTitle(title)
  }

  isSameAudience (audience: db.Audience) {
    if (!this.selectedAudience || Object.keys(this.selectedAudience).length === 0) {
      return false
    }
    if (this.selectedAudience.id) {
      return this.selectedAudience.id === audience.id
    }
    if (this.selectedAudience.title) {
      return this.selectedAudience.title === audience.title
    }
    return false
  }

  updateSelectedAudience (selectedAudience: db.Audience, groupTitle: string) {
    let groupType: string
    if (groupTitle === 'Legacy Audiences') {
      groupType = 'Legacy'
    } else if (groupTitle === 'Featured Audiences') {
      groupType = 'Featured'
    } else if (groupTitle === 'All Audiences') {
      groupType = 'Account'
    } else {
      groupType = 'NA'
    }
    this.$emit('update', { selectedAudience, groupType })
  }
}
